import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./stamps.css";

import StampGrid from "./StampGrid";
import FooterBar from "./FooterBar";
import PopText from "../Utility/PopText";

import { supabase } from "../../Backend/supabaseClient";

export async function fetchDoYouKnowStamps(limit = 12) {
  const { data, error } = await supabase
    .rpc("get_random_qa", { lim: limit });

  if (error) throw new Error(error.message);

  return (data || []).map((row) => ({
    id: `q${row.id}`,   // keeps your StampGrid logic unchanged
    question: row.question,
    answer: row.answer,
  }));
}

// src/data/qaStamps.js

export const qaStamps = [
  {
    id: "q1",
    question: "Who is the first President of India?",
    answer: "Dr. Rajendra Prasad was the first president of india.",
  },
  {
    id: "q2",
    question: "Who is known as the Father of the Nation in India?",
    answer: "Mahatma Gandhi",
  },
  {
    id: "q3",
    question: "What is the capital of India?",
    answer: "New Delhi",
  },
  {
    id: "q4",
    question: "Which planet is known as the Red Planet?",
    answer: "Mars",
  },
  {
    id: "q6",
    question: "What is the largest ocean on Earth?",
    answer: "Pacific Ocean",
  },
  {
    id: "q5",
    question: "Who wrote the National Anthem of India?",
    answer: "Rabindranath Tagore",
  },
  {
    id: "q7",
    question: "What is the chemical symbol for water?",
    answer: "H₂O",
  },
  {
    id: "q8",
    question: "Who invented the telephone?",
    answer: "Alexander Graham Bell",
  },
  {
    id: "q9",
    question: "Which is the smallest prime number?",
    answer: "2",
  },
  {
    id: "q10",
    question: "What gas do plants absorb from the atmosphere?",
    answer: "Carbon Dioxide (CO₂)",
  },
];

export default function HomeScreenBoard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState(qaStamps);
  const [flipped, setFlipped] = useState(() => new Set());

  // ✅ NEW: load from backend (12 items) and convert to needed format
  const loadFromBackend = async () => {
    try {
      setLoading(true);
      const fresh = await fetchDoYouKnowStamps(12);

      // If DB empty, keep existing local qaStamps
      if (fresh && fresh.length > 0) {
        setItems(fresh);
        setFlipped(new Set()); // reset flips for new cards
      }
    } catch (e) {
      console.error("Failed to load Do You Know stamps:", e);
      // keep existing qaStamps as fallback
    } finally {
      setLoading(false);
    }
  };

  // ✅ NEW: initial load on mount
  useEffect(() => {
    loadFromBackend();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getNew = async () => {
    try {
      const fresh = await fetchDoYouKnowStamps(12);
      if (fresh && fresh.length > 0) {
        setItems(fresh);
        setFlipped(new Set()); // reset flips for new cards
      }
    } catch (e) {
      console.error("Failed to load New Do You Know stamps:", e);
    }
  }

  const rotations = useMemo(() => {
    const map = new Map();
    items.forEach((it, idx) => {
      const seed = [...it.id].reduce((acc, ch) => acc + ch.charCodeAt(0), 0) + idx * 13;
      const r = ((seed % 9) - 4) * 0.8; // -3.2..+3.2 deg
      map.set(it.id, r);
    });
    return map;
  }, [items]);

  const onToggle = (id) => {
    setFlipped((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-xl font-semibold">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full bg-white text-neutral-900">
      <div className="paper-grid min-h-screen">
        <div className="mx-auto w-full max-w-6xl px-4 pt-8 pb-28">
          <div className="text-center">
            <h1 className="text-4xl font-bold mb-4">
              <PopText className="text-orange-600">Do</PopText>
              <PopText className="text-black-600">You</PopText>
              <PopText className="text-blue-600">Know?</PopText>
            </h1>
          </div>

          <div className="mt-10">
            <StampGrid
              items={items}
              flippedSet={flipped}
              onToggle={onToggle}
              rotations={rotations}
            />
          </div>
        </div>

        <FooterBar
          left={{ label: "More - Do You Know", onClick: getNew }}   // ✅ hook it here
          center={{ label: "GIVE FEEDBACK", onClick: () => { } }}             // ✅ fix: must be function
          right={{ label: "More About Us", onClick: () => { navigate("/about")} }}              // ✅ fix: must be function
        />
      </div>
    </div>
  );
}
